import { Stack } from '@mui/material';

import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';

import ShortlistList from '@/north-star/care/shortlists/ShortlistList';
import { type PublishedShortlist } from '@/north-star/care/shortlists/fixtures';

// The care search page content: the Stack under Body that holds the page
// header and the list of published shortlists. It IS a Stack (spacing 2)
// composing the named sections.
const CareSearchContent = ({
  heading,
  description,
  shortlists,
  onOpen,
}: {
  heading?: string;
  description?: string;
  shortlists: PublishedShortlist[];
  onOpen: (shortlist: PublishedShortlist) => void;
}) => (
  <Stack spacing={2}>
    {heading && (
      <PageHeader variant='h2' title={heading} description={description} />
    )}
    <ShortlistList shortlists={shortlists} onOpen={onOpen} />
  </Stack>
);

export default CareSearchContent;
